<template>
  <div>
    <h1 class="header-style">
      Visitor <br>Check-in
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-in.
    </p>
    <v-stepper
      v-if="orgSettings.questionnaire_verification"
      v-model="userCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckIn > 1"
          step="1"
          color="#37474F"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 2"
          step="2"
          color="#37474F"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 3"
          step="3"
          color="#37474F"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 4"
          step="4"
          color="#37474F"
        />
      </v-stepper-header>
    </v-stepper>
    <v-stepper
      v-if="!orgSettings.questionnaire_verification"
      v-model="userCheckIn"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckIn > 1"
          step="1"
          color="#000"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 2"
          step="2"
          color="#000"
        />
        <v-divider />
        <v-stepper-step
          :complete="userCheckIn > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <visitor-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <visit-purpose
        v-if="showVisitPurposePage"
        @visit-purpose-stored="toThirdStep"
      />
      <visitor-questions
        v-if="showQuestionsPage"
        @questions-answered="toFourthStep"
      />
      <review-visit-details
        v-if="showVisitReviewPage"
        @checkin-completed="checkInCompleted"
      />
    </div>
  </div>
</template>

<script>
  import VisitorLocationVerification from '../dialogComponents/VisitorDialogs/checkin/VisitorLocationVerification.vue';
  import VisitPurpose from '../dialogComponents/VisitorDialogs/checkin/VisitPurpose.vue';
  import VisitorQandA from '../dialogComponents/VisitorDialogs/checkin/VisitorQandA.vue';
  import ReviewVisitDetails from '../dialogComponents/VisitorDialogs/checkin/ReviewVisitDetails.vue';
  import global from '../../../../mixins/global';
  export default {
    name: 'VisitorCheckInPage',
    components: {
      'visitor-location-verification': VisitorLocationVerification,
      'visit-purpose': VisitPurpose,
      'visitor-questions': VisitorQandA,
      'review-visit-details': ReviewVisitDetails,

    },
    mixins: [global],
    data () {
      return {
        userCheckIn: null,
        showLocationVerificationPage: false,
        step1SuccessColor: '',
        showVisitPurposePage: false,
        step2SuccessColor: '',
        showQuestionsPage: false,
        step3SuccessColor: '',
        showVisitReviewPage: false,
      };
    },
    computed: {
      checkInMethodType () {
        return this.$store.getters['swiftuser/getCheckInMethodType'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    async mounted () {
      this.loadOnMount();
      this.fetchOrgDetails();
      this.checkSettingsLocation();
    },
    methods: {
      checkSettingsLocation () {
          this.userCheckIn = 1;
          this.showLocationVerificationPage = true;
          this.showWorkDetailsPage = false;
          this.isLocationEnabled = false;
          this.showQuestionsPage = false;
          this.showVisitPurposePage = false;
      },
      checkSettingsQuestionnaire () {
        if (!this.orgSettings.questionnaire_verification) {
          this.showQuestionsPage = false;
          this.showVisitReviewPage = true;
          this.userCheckIn = 3;
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.selectedOrganization);
      },
      loadOnMount () {
        if (this.checkInMethodType === null || Object.keys(this.selectedOrganization).length === 0) {
          this.$router.push({ name: 'CheckIn' });
        }
      },
      toSecondStep () {
        this.userCheckIn = 2;
        this.showLocationVerificationPage = false;
        this.showWorkDetailsPage = false;
        this.isLocationEnabled = false;
        this.showQuestionsPage = false;
        this.showVisitPurposePage = true;
      },
      toThirdStep () {
        this.userCheckIn = 3;
        this.step2SuccessColor = '#00796B';
        this.showLocationVerificationPage = false;
        this.showWorkDetailsPage = false;
        this.isLocationEnabled = false;
        this.showQuestionsPage = true;
        this.showVisitPurposePage = false;
        this.checkSettingsQuestionnaire();
      },
      toFourthStep () {
          this.step3SuccessColor = '#00796B';
          this.userCheckIn = 4;
          this.showQuestionsPage = false;
          this.showLocationVerificationPage = false;
          this.showVisitPurposePage = false;
          this.showVisitReviewPage = true;
      },
      checkInCompleted () {
        this.$router.push({ name: 'Checkin Success' });
      },
    },
  };
</script>
